module.exports = __webpack_public_path__ + "static/media/tendericon01.cf454aa4.png";